// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 768 ? "App" : chunkId) + "." + {"130":"e51a0b53","768":"9b81131e"}[chunkId] + ".chunk.css";
};